<template>
  <div
    class="result-box mb-4"
    :style="{
      'background-color': setBgColorAttendanceStatus(title)
    }"
  >
    <div
      class="mt-2 mb-2 w-full text-center flex justify-center gap-4 items-center"
    >
      <span class="number-txt text-center">{{ numberOfStudent }}</span>
      <span class="percent-txt text-center" v-if="isPercent">
        ({{ percentTxt }}%)
      </span>
    </div>
    <div class="result-box__info h-full">
      <div
        class="title text-center h-full flex items-center font-bold"
        :style="{
          color: setColorAttendanceStatus(title)
        }"
      >
        {{ generateTitleDaily(title) }}
      </div>
    </div>
  </div>
</template>

<script>
import { generateStatus } from "@/helpers/text-helper";
import {
  setColorAttendanceStatus,
  setBgColorAttendanceStatus
} from "../../../../helpers/color";

export default {
  props: ["numberOfStudent", "percentTxt", "title", "isPercent"],
  data() {
    return {
      generateStatus,
      setColorAttendanceStatus,
      setBgColorAttendanceStatus
    };
  },
  methods: {
    generateTitleDaily(title) {
      return title === "Student"
        ? this.$t("attendance_report.student.student")
        : this.generateStatus(title);
    }
  }
};
</script>

<style lang="scss" scoped>
.result-box {
  @apply p-2 text-[#5d5fef] text-[1.2rem] w-[15%] h-full;
  @apply flex flex-col items-center;
  @apply bg-white;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12),
    0px 6px 10px rgba(0, 0, 0, 0.14);
  border-radius: 4px;

  .number-txt {
    @apply mt-2;
    @apply text-lg font-medium;
    @apply leading-normal;
    color: currentColor;
  }
  .percent-txt {
    @apply mt-2;
    @apply text-sm font-medium;
    @apply leading-normal;
  }

  .title {
    @apply text-gray-800 font-medium text-base;
  }
}
</style>
